import { useState } from 'react';
import { getFullUrl } from '../utils/utils';
import { getRudderstackAnonymousId } from '../utils/rudderstackAnonymousId';

export const useSubmitLead = () => {
  const [loading, setLoading] = useState(false);

  const submitLead = async ({ firstName, lastName, email, campaignId, campaignName, acceptedTerms, acceptedMarketing, leadType }) => {
    setLoading(true);

    const leadUrl = window.gon.lead_url;
    const apiEndpoint = getFullUrl(leadUrl);

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: 'premium',
          // Browser SDK id so the backend generate_lead lands on the same Braze
          // profile; JSON.stringify drops the key when it is undefined.
          anonymous_id: getRudderstackAnonymousId(),
          lead: {
            first_name: firstName,
            last_name: lastName,
            campaign_id: campaignId,
            campaign_name: campaignName,
            email: email,
            accepted_terms: acceptedTerms,
            accepted_marketing: acceptedMarketing,
            lead_type: leadType
          },
          utm_source: window.location.href.match(/utm_source=([^&]+)/)?.[1],
          utm_medium: window.location.href.match(/utm_medium=([^&]+)/)?.[1],
          utm_campaign: window.location.href.match(/utm_campaign=([^&]+)/)?.[1],
          utm_term: window.location.href.match(/utm_term=([^&]+)/)?.[1],
          utm_content: window.location.href.match(/utm_content=([^&]+)/)?.[1],
          gclid: window.location.href.match(/gclid=([^&]+)/)?.[1],
        }),
      });

      const data = await response.json();

      // The API reports duplicate submissions ("email is already used") as
      // HTTP 200 with success: false — treat those as errors so the user
      // sees the error message instead of a false success toast.
      if (!response.ok || data.success === false) {
        throw new Error(data.message || `Error: ${response.status}`);
      }

      return {
        success: true,
        message: data.message || 'Email submitted successfully!',
        lead: data.lead,
        coupon: data.coupon,
        prefix: data.prefix,
      };
    } catch (error) {
      // Surface server-provided validation messages (e.g. "email is already
      // used", claim-limit reached); fall back to a generic message for
      // network/HTTP failures.
      const errorMessage = error.message && !error.message.startsWith('Error:')
        ? error.message
        : 'Something went wrong. Please try again.';

      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { submitLead, loading };
};
